// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Profile_Wrapper__15lAj","Profile":"Profile_Profile__27P17"};